<script setup>
/**
 * BrowserFrame — a neutral browser chrome around product screenshots.
 * Keeps every screenshot on the page in the same, calm frame.
 */
defineProps({
  url: { type: String, default: 'app.bifrost.events' }
})
</script>

<template>
  <div class="rounded-xl border border-slate-200 bg-white shadow-[0_24px_60px_-24px_rgba(15,23,42,0.25)] overflow-hidden">
    <div class="flex items-center gap-3 px-4 py-2.5 border-b border-slate-200 bg-slate-50" aria-hidden="true">
      <div class="flex gap-1.5">
        <span class="w-2.5 h-2.5 rounded-full bg-slate-300"></span>
        <span class="w-2.5 h-2.5 rounded-full bg-slate-300"></span>
        <span class="w-2.5 h-2.5 rounded-full bg-slate-300"></span>
      </div>
      <div class="flex-1 max-w-xs mx-auto">
        <div class="text-[11px] font-mono text-slate-400 bg-white border border-slate-200 rounded-md px-3 py-1 text-center truncate" dir="ltr">
          {{ url }}
        </div>
      </div>
      <div class="w-10"></div>
    </div>
    <slot />
  </div>
</template>
